import { cn } from '@/util/cn';
import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

const typographyVariants = cva('', {
  variants: {
    variant: {
      h1: 'text-6xl font-bold tracking-tight',
      h2: 'text-5xl font-bold tracking-tight',
      h3: 'text-4xl font-bold tracking-tight',
      h4: 'text-3xl font-bold tracking-tight',
      h5: 'text-2xl font-bold tracking-tight',
      h6: 'text-xl font-bold tracking-tight',
      subtitle1: 'text-lg font-semibold tracking-tight',
      subtitle2: 'text-md font-semibold tracking-tight',
      body1: 'text-base font-normal',
      body2: 'text-sm font-normal',
      caption: 'text-xs font-normal tracking-tight'
    }
  },
  defaultVariants: {
    variant: 'body1'
  }
});

export interface typographyProps
  extends
    Omit<React.HTMLAttributes<HTMLDivElement>, 'color'>,
    VariantProps<typeof typographyVariants> {}

function Typography({ className, variant, ...props }: typographyProps) {
  return <div className={cn(typographyVariants({ variant }), className)} {...props} />;
}

// eslint-disable-next-line react-refresh/only-export-components
export { Typography, typographyVariants };
